import contractPageForm from '../pages/Guest/ContractPage/ContractPageForm/ContractPageFormReducer';
import CollapsibleAddressFields from '../components/CollapsibleAddressFields/CollapsibleAddressFieldsReducer';

export const reducersDE = {
    contractPageForm,
    CollapsibleAddressFields
};
